// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sidebar-resource-item-list[data-v-5d21a0d6] {\n    color: #8C979A !important;\n}\n.resource-item[data-v-5d21a0d6]{\n    margin-bottom: 15px;\n    margin-left: 15px;\n    font-weight: bold;\n    color: #8C979A !important;\n}\n.resource-item *[data-v-5d21a0d6]:hover {\n    cursor: pointer;\n}\na[data-v-5d21a0d6] {\n    color: teal;\n}\n", ""]);
// Exports
module.exports = exports;
